import type { IconName } from "@similarweb/icons";
import type { ITableCellProps } from "app/components/React/Table/interfaces/ITableCellProps";
import type { ReactElement } from "react";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { StyledCell, StyledSWReactIcon } from "./styles";

export type IconWithChildrenCellProps = ITableCellProps & {
    iconName?: IconName;
    children: ReactElement[];
};

const IconWithChildrenCell = ({ value, iconName, children, className }: IconWithChildrenCellProps) => {
    return (
        <StyledCell
            className={className}
            data-automation-cell-value={value}
        >
            {iconName ? (
                <StyledSWReactIcon
                    iconName={iconName}
                    size="sm"
                />
            ) : null}

            <FlexColumn>{children}</FlexColumn>
        </StyledCell>
    );
};

export default IconWithChildrenCell;
